import { render, staticRenderFns } from "./BenefitsIllness.vue?vue&type=template&id=34ce8130&scoped=true&"
import script from "./BenefitsIllness.vue?vue&type=script&lang=js&"
export * from "./BenefitsIllness.vue?vue&type=script&lang=js&"
import style0 from "./BenefitsIllness.vue?vue&type=style&index=0&id=34ce8130&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ce8130",
  null
  
)

export default component.exports